import React, { useEffect } from 'react'
import { useTranslation } from '../../utils/convergence'
import { Head } from '../../component'
import { CheckoutPage } from '../../model'
import { useAppRouter } from '../../state'
import { Route } from '../../config/router'
import { RetryCreditFreeze } from '../../component/RetryCreditFreeze'
import { TrackOnMount } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'

export const RetryCreditFreezePage: CheckoutPage = () => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const pageTitle = t('consumerLending:retryCreditFreeze:title')

  useEffect(() => {
    router.prefetch(Route.SUMMARY)
    router.prefetch(Route.PAYMENT_OPTIONS)
  }, [])

  return (
    <>
      <Head title={pageTitle} />
      <RetryCreditFreeze />
      <TrackOnMount eventName={TrackingEvent.VIEWED_CL_RETRY_CREDIT_FREEZE_PAGE} />
    </>
  )
}
